import { toast } from 'material-react-toastify';

import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { coachKeys } from '@/lib/query/keys/coach';
import { Coach } from '@addmile/backend-client';
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

export const useCoaches = () => {
  return useQuery<Coach[]>({
    queryKey: coachKeys.lists(),
    queryFn: async () => {
      try {
        const token = await getAuthToken();
        const { data } = await hubApi.getCoachesHub(withAuthHeader(token));

        return data.coaches;
      } catch (error) {
        Sentry.captureException(`Failed to fetch coaches: ${error.message}`);
        toast.error(`Failed to fetch coaches: ${error.message}`);
        return [];
      }
    },
    staleTime: 5 * 60 * 1000,
  });
};
